import React, { useEffect, useState } from 'react'
import Card from '../../controls/Card'
import { GetAll } from '../../../configurations/crud/doctorsFastNoteCurd'
import {
  MdErrorOutline,
  MdOutlinePersonOff,
  MdOutlineFreeBreakfast,
  MdOutlinePowerSettingsNew,
  MdOutlineEmergency,
} from 'react-icons/md'
import { useToast } from '../../controls/Toast/ToastService'
import { FaBell, FaDisease, FaUserMd, FaUserPlus, FaHeartbeat } from "react-icons/fa";
import { HiOutlineClipboardCheck } from "react-icons/hi";
import { FaCircleInfo } from 'react-icons/fa6'
import { GetEDoctorStatusName } from '../../../configurations/enums/EDoctorStatus'
import * as opdCentersCrud from '../../../configurations/crud/opdCentersCrud'
import { useParams } from 'react-router-dom'
import ReceptionEmergency from './ReceptionEmergency'
import ReceptionConfirmed from './ReceptionConfirmed'
import ReceptionRegistered from './ReceptionRegistered'
import moment from 'moment'
import * as opdRegisteredCrud from '../../../configurations/crud/opdRegisteredCrud'
import { getLoginInfo } from '../../../configurations/auth/getLoginInfo'
import PatientHistory from './PatientHistory'
import ContainerTwo from '../../base/ContainerTwo'
import { HubConnectionBuilder, LogLevel } from '@microsoft/signalr';
import { LIVE_URL } from '../../../configurations/initUrls'
import WarningPopUp from './WarningPopUp'
import DaillyShortReport from '../report/DaillyShortReport'
import { VscDebugDisconnect } from "react-icons/vsc";
import LoadingContainer from '../../controls/LoadingContainer'
import { allowSleep, keepAwake } from '../../../configurations/native/screenTime'
import { useKeepAwake } from 'react-keep-awake';
import useGlobalLoader from '../../../configurations/useGlobalLoader'
import { PiPlugsConnectedFill } from 'react-icons/pi'

export default function DoctorDisplay() {
  const { start, end } = useGlobalLoader()
  const [fastNotesData, setFastNotesData] = useState([])
  const [loding, setLoding] = useState(false)
  const [doctorStatus, setDoctorStatus] = useState(1);
  const { centerid } = useParams()
  const [viewUsers, setViewUsers] = useState(1);
  const [centerData, setCenterData] = useState();
  const [currentData, setCurrentData] = useState();
  const toast = useToast()
  const loginInfo = getLoginInfo()
  const [isOpenUnavailable, setIsOpenUnavailable] = useState(false)
  const [nextPatientData, setNextPatientData] = useState();
  const [note, setNote] = useState();
  const [isOpenPop, setIsOpenPop] = useState(false)
  const [lodingCrud, setLodingCrud] = useState(false)
  const [isDailyUpdate, setIsDailyUpdate] = useState(0)
  useKeepAwake()
  useEffect(() => {
    keepAwake()
    return () => {
      allowSleep()
    }
  }, [])


  ///Chat Start Block\
  const [connection, setConnection] = useState();
  const [messages, setMessages] = useState([]);
  const [users, setUsers] = useState([]);
  const joinroom = async (user, room) => {
    try {
      const connection = new HubConnectionBuilder()
        .withUrl(LIVE_URL)
        .configureLogging(LogLevel.Information)
        .build();

      connection.on("UsersInRoom", (users) => {
        setUsers(users);
      });

      connection.on("ReceiveMessage", (user, message) => {
        console.log(message)
        switch (message) {
          case "1": { GetCenterDetails(); break; }
          case "2": { GetPatientInTheCabin(); setCurrentData(); setIsDailyUpdate(pre => pre + 1); break; }
          case "3": { GetPatientInTheCabin(); setCurrentData(); break; }
          case "4": { GetPatientInTheCabin(); setCurrentData(); setIsDailyUpdate(pre => pre + 1); break; }
        }
        setMessages(messages => [...messages, { user, message }]);
      });

      connection.onclose(e => {
        setConnection();
        setMessages([]);
        setUsers([]);
      })

      connection.onclose(e => {
        setConnection();
        setMessages([]);
      });

      await connection.start();
      await connection.invoke("JoinRoom", { user, room });
      setConnection(connection);

    } catch (e) {
      console.log(e);
    }
  }

  const sendMessage = async (message) => {
    try {
      await connection.invoke("SendMessage", message);
    } catch (e) {
      console.log(e);
    }
  }

  const closeConnection = async () => {
    try {
      await connection.stop();
    } catch (e) {
      console.log(e);
    }
  }

  ///Chat End Block
  const reConnect = () => {
    joinroom(loginInfo.userName + "_" + centerid + "_Doctor", loginInfo.userName + "_" + centerid)
    toast.open("Connected", <VscDebugDisconnect />, "success")
  }

  useEffect(() => {
    joinroom(loginInfo.userName + "_" + centerid + "_Doctor", loginInfo.userName + "_" + centerid)
    GetFastNotes()
    GetCenterDetails()
    GetPatientInTheCabin()
    GetPatientWhoNext()
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const GetFastNotes = () => {
    setLoding(true)
    start()
    GetAll().then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setFastNotesData(mdata.data)
      } else {
        setFastNotesData([])
        //toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setFastNotesData([])
      //toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const GetDoctorChangeStatus = (s) => {
    setLoding(true)
    start()
    opdCentersCrud.DoctorChangeStatus({
      Status: s,
      Id: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.succeeded) {
        setDoctorStatus(s)
        sendMessage("1")
        toast.open("Doctor is " + GetEDoctorStatusName(s), <FaCircleInfo />, "info")
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const GetCenterDetails = () => {
    setLoding(true);
    start()
    opdCentersCrud.GetById(centerid)
      .then((res) => {
        let mdata = res.data;
        if (mdata.result.succeeded) {
          setDoctorStatus(mdata.data.doctorStatus)
          setCenterData(mdata.data);
        } else {
          setCenterData();
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger");
        }
        setLoding(false);
        end()
      })
      .catch((errors) => {
        setCenterData();
        // toast.open(errors, <MdErrorOutline />, "danger");
        setLoding(false);
        end()
      });
  }

  const GetPatientInTheCabin = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.GetPatientInTheCabin({
      DoctorId: loginInfo.doctorId,
      CenterId: centerid
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
      } else {
        setCurrentData()
        // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
      }
      setLoding(false)
      end()
    }).catch(errors => {
      setCurrentData()
      // toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
    })
  }

  const PatientUnavailable = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.PatientUnavailable({
      CenterId: centerid,
      Id: currentData.id
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("3")
        sendMessage("5")
        setIsOpenUnavailable(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenUnavailable(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
      setIsOpenUnavailable(false)
    })
  }

  const GetPatientWhoNext = () => {
    setLoding(true)
    start()
    try {
      opdRegisteredCrud.GetPatientWhoNext({
        DoctorId: loginInfo.doctorId,
        CenterId: centerid
      }).then(res => {
        let mdata = res.data
        if (mdata.result.succeeded) {
          setNextPatientData(mdata.data)
        } else {
          setNextPatientData()
          // toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        }
        setLoding(false)
        end()
      }).catch(errors => {
        setNextPatientData()
        // toast.open(errors, <MdErrorOutline />, "danger")
        setLoding(false)
        end()
      })
    }
    catch (error) {
      alert(error)
    }
  }

  const NextPatient = () => {
    setLoding(true)
    start()
    opdRegisteredCrud.NextPatient({
      CenterId: centerid,
      Note: note
    }).then(res => {
      let mdata = res.data
      if (mdata.result.succeeded) {
        setCurrentData(mdata.data)
        GetPatientWhoNext()
        sendMessage("2")
        sendMessage("5")
        setIsOpenPop(false)
      } else {
        toast.open(mdata.result.message, <MdErrorOutline />, "danger")
        setIsOpenPop(false)
      }
      setLoding(false)
      end()
    }).catch(errors => {
      toast.open(errors, <MdErrorOutline />, "danger")
      setLoding(false)
      end()
      setIsOpenPop(false)
    })
  }

  // ---- view config ----
  const TABS = [
    { id: 1, label: "Patient", Icon: FaUserMd, color: "bg-blue-500" },
    { id: 2, label: "Registered", Icon: FaUserPlus, color: "bg-emerald-500" },
    { id: 3, label: "Confirmed", Icon: HiOutlineClipboardCheck, color: "bg-green-600" },
    { id: 4, label: "Emergency", Icon: FaHeartbeat, color: "bg-red-500" },
  ]
  const DOCTOR_STATES = [
    { id: 1, label: "In The Cabin", Icon: FaUserMd, color: "bg-green-500" },
    { id: 4, label: "On Rest", Icon: MdOutlineFreeBreakfast, color: "bg-orange-500" },
    { id: 0, label: "Offline", Icon: MdOutlinePowerSettingsNew, color: "bg-red-500" },
  ]

  const centerTitle = centerData &&
    `${centerData.centerName} · ${moment(centerData.opdStartTime).format("LT")}–${moment(centerData.opdEndTime).format("LT")}`

  // connection indicator (shared by both card headers)
  const ConnectionButton = () => (
    <button
      onClick={reConnect}
      title={connection ? "Live · tap to reconnect" : "Disconnected · tap to reconnect"}
      className={`relative grid h-8 w-8 shrink-0 place-items-center rounded-lg transition active:scale-95 ${connection
        ? "bg-emerald-50 text-emerald-600 hover:bg-emerald-100"
        : "bg-red-50 text-red-600 hover:bg-red-100"}`}
    >
      {connection ? <PiPlugsConnectedFill /> : <VscDebugDisconnect />}
      <span className={`absolute -right-0.5 -top-0.5 h-2 w-2 rounded-full ${connection ? "bg-emerald-500" : "bg-red-500"}`} />
      <span className="sr-only">{connection ? "Connected" : "Disconnected"}</span>
    </button>
  )

  return (
    <ContainerTwo>
      <div className="my-2" />
      <DaillyShortReport refresh={isDailyUpdate} />

      <div className="flex flex-col gap-4 pb-24 lg:flex-row lg:items-start">
        {loding ? (
          <div className="w-full">
            <Card isBorder={true} isBack={true} title="Doctor">
              <LoadingContainer text="Please wait..." />
            </Card>
          </div>
        ) : currentData && !loding ? (
          <>
            {/* ===== Left : queue panel ===== */}
            <div className="w-full lg:w-7/12">
              <Card
                isBorder={true}
                isBack={true}
                title={
                  <div className="flex w-full items-center justify-between gap-2">
                    <span className="truncate">{centerTitle}</span>
                    <ConnectionButton />
                  </div>
                }
              >
                {/* toolbar: tabs + unavailable */}
                <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
                  <div className="flex max-w-full gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
                    {TABS.map(({ id, label, Icon, color }) => (
                      <button
                        key={id}
                        type="button"
                        onClick={() => setViewUsers(id)}
                        aria-pressed={viewUsers == id}
                        className={`flex shrink-0 items-center gap-1.5 rounded-lg px-3 py-2 text-xs font-semibold transition sm:px-4 sm:text-sm ${viewUsers == id ? `${color} text-white shadow` : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                      >
                        <Icon className="text-sm sm:text-base" />
                        {label}
                      </button>
                    ))}
                  </div>

                  <button
                    type="button"
                    onClick={PatientUnavailable}
                    className="inline-flex shrink-0 items-center justify-center gap-2 rounded-xl bg-orange-500 px-5 py-2 text-sm font-semibold text-white shadow transition hover:bg-orange-400 focus:ring-2 focus:ring-orange-500 active:scale-95"
                  >
                    <MdOutlinePersonOff className="text-lg" /> Mark Unavailable
                  </button>
                </div>

                {/* tab content */}
                <div className="mt-4">
                  {viewUsers == 1 && currentData && <PatientHistory currentData={currentData} />}
                  {viewUsers == 2 && <ReceptionRegistered isActive={viewUsers == 2} searchTerm="" isSearch={0} />}
                  {viewUsers == 3 && <ReceptionConfirmed isActive={viewUsers == 3} searchTerm="" isSearch={0} />}
                  {viewUsers == 4 && <ReceptionEmergency isActive={viewUsers == 4} searchTerm="" isSearch={0} />}
                </div>
              </Card>
            </div>

            {/* ===== Right : controls + quick notes ===== */}
            <div className="w-full lg:sticky lg:top-[80px] lg:w-5/12">
              <Card
                isBorder={true}
                title={
                  <span className="flex items-center gap-1.5">
                    <FaUserMd className="text-brand-500" /> Doctor Status
                  </span>
                }
              >
                {/* doctor status segmented control */}
                <div className="flex max-w-full gap-1 overflow-x-auto rounded-xl bg-gray-100 p-1">
                  {DOCTOR_STATES.map(({ id, label, Icon, color }) => (
                    <button
                      key={id}
                      type="button"
                      onClick={() => GetDoctorChangeStatus(id)}
                      aria-pressed={doctorStatus == id}
                      className={`flex flex-1 shrink-0 items-center justify-center gap-1.5 rounded-lg px-2 py-2 text-xs font-semibold transition sm:px-3 sm:text-sm ${doctorStatus == id ? `${color} text-white shadow` : "text-gray-500 hover:bg-white hover:text-gray-700"}`}
                    >
                      <Icon className="text-sm sm:text-base" />
                      {label}
                    </button>
                  ))}
                </div>

                {/* quick notes */}
                <div className="mt-4">
                  <div className="mb-1 flex items-center gap-1.5 px-1 text-[11px] font-semibold uppercase tracking-wide text-gray-400">
                    <FaDisease className="text-rose-400" />
                    Quick Notes — tap to call next patient
                  </div>
                  {fastNotesData.length ? (
                    <ul className="max-h-[55vh] divide-y divide-gray-100 overflow-y-auto lg:max-h-[560px]">
                      {fastNotesData.map((item, index) => (
                        <li
                          key={item.id ?? index}
                          onClick={() => { setNote(item.note); setIsOpenPop(!isOpenPop) }}
                          className="flex cursor-pointer items-center gap-3 rounded-lg px-2 py-3.5 transition hover:bg-gray-50 active:bg-green-50"
                        >
                          <span className="grid h-8 w-8 shrink-0 place-items-center rounded-lg bg-rose-50 text-rose-500">
                            <FaDisease />
                          </span>
                          <p className="truncate text-sm font-medium text-gray-800">{item.note}</p>
                        </li>
                      ))}
                    </ul>
                  ) : (
                    <div className="flex flex-col items-center gap-2 py-10 text-center text-sm text-gray-400">
                      <FaDisease className="text-2xl opacity-50" />
                      No quick notes available.
                    </div>
                  )}
                </div>
              </Card>
            </div>
          </>
        ) : (
          <div className="w-full">
            <Card
              isBorder={true}
              isBack={true}
              title={
                <div className="flex w-full items-center justify-between gap-2">
                  <span className="truncate">
                    {centerData && (centerData.centerName + " | " + moment(centerData.opdStartTime).format("LT") + "-" + moment(centerData.opdEndTime).format("LT"))}
                  </span>
                  <ConnectionButton />
                </div>
              }
            >
              <div className="flex flex-col items-center justify-center gap-3 py-16 text-center">
                <span className="grid h-16 w-16 place-items-center rounded-full bg-amber-50 text-3xl text-amber-500">
                  <FaCircleInfo />
                </span>
                <h1 className="text-xl font-semibold text-gray-700 sm:text-2xl">OPD Not Started Yet</h1>
                <p className="text-sm text-gray-500">Please call the reception to start the OPD.</p>
              </div>
            </Card>
          </div>
        )}
      </div>

      {/* ===== floating actions ===== */}
      <div className="fixed bottom-4 left-4 z-40 flex items-center gap-2 sm:gap-3">
        <button
          onClick={() => sendMessage("5")}
          title="Ring bell"
          className="grid h-14 w-14 place-items-center rounded-full bg-white text-gray-600 shadow-xl ring-1 ring-gray-100 transition hover:text-green-500 active:scale-95"
        >
          <FaBell size={26} />
          <span className="sr-only">Ring bell</span>
        </button>
        <button
          onClick={() => sendMessage("25")}
          className="inline-flex items-center gap-2 rounded-full bg-red-500 px-4 py-3 text-sm font-bold text-white shadow-xl transition hover:bg-red-600 active:scale-95 sm:px-5"
        >
          <MdOutlineEmergency className="text-lg" />
          <span className="hidden xs:inline sm:inline">Call EMERGENCY!</span>
          <span className="xs:hidden sm:hidden">EMERGENCY</span>
        </button>
      </div>

      <WarningPopUp call={NextPatient} isOpen={isOpenPop} setIsOpen={setIsOpenPop} loding={lodingCrud} text={"Are you sure to call Next Patient?"} />
    </ContainerTwo>
  )
}